module.exports = __webpack_public_path__ + "static/img/btn x.fe806131.svg";